<template>
  <div>
    <img class="bg" :src="require('@/assets/images/login-page/wel_bg.png')" alt="">
    <div class="content flex-column justify-center">
      <div class="flex-column" style="padding: 0 18px;">
        <img class="logo" :src="require('@/assets/images/login-page/wel_title.png')" alt="">
        <div class="desc">To use the ARCTIC DOLPHIN App you must be aged 21 years above. Please verify you are before entering the app.</div>
      </div>
      <div class="btn confirm" @click="$router.push('register')">21+ENTER</div>
      <div class="btn cancel" @click="exitCurAPP">UNDER 21</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
  },
  methods: {
    exitCurAPP() {
      window.webkit.messageHandlers.exitCurAPP.postMessage("Meaningless"); // 告诉宿主 退出当前APP
    }
  }
}
</script>

<style lang="less" scoped>
  .bg {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
  .content {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 60px;
    .logo {
      width: 80%;
    }
    .desc {
      margin-top: 39px;
      color: #282828;
      font-size: 27px;
      line-height: 50px;
      text-align: justify;
    }
    .btn {
      width: 100%;
      text-align: center;
      height: 78px;
      line-height: 78px;
      border-radius: 40px;
    }
    .confirm {
      margin-top: 190px;
      color: #fff;
      background: linear-gradient(30deg, #3EE191, #24DEDD);
    }
    .cancel {
      margin-top: 30px;
      color: #282828;
      border: 3px solid #282828;
    }
  }
</style>
